module.exports = __webpack_public_path__ + "static/media/tom-ford-noir-big.03330b91.png";